import { Backend } from '@shared/datastore/core';
import { SearchMyProjectsBuyerResultAjax } from './search-my-projects-buyer.backend-model';

declare module '../core/backend' {
  interface BackendAjaxFetchTypes {
    searchMyProjectsBuyer: SearchMyProjectsBuyerResultAjax;
  }
}

export const searchMyProjectsBuyerBackend: Backend<'searchMyProjectsBuyer'> = {
  fetch: () => ({
    endpoint: `search/myProjects.php`,
    isGaf: true,
    params: { buyer: 'true', active: 'true' },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-my-projects-buyer/search-my-projects-buyer.backend.ts